import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const DEFAULT_SCREENING_METHOD_TEXT =
  "Tests have been performed on fully automatic analyser Vitros ECI by CLIA method.";

const OtherConfig = () => {
  const [screeningMethodText, setScreeningMethodText] = useState(
    DEFAULT_SCREENING_METHOD_TEXT
  );
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BLOOD_BANK}/blood-bank-config/getBloodBankConfig`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const text = response.data?.data?.screeningMethodText;
        setScreeningMethodText(
          text && String(text).trim() ? text : DEFAULT_SCREENING_METHOD_TEXT
        );
      } catch (error) {
        toast.error("Failed to load blood bank config");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSave = async () => {
    const text = screeningMethodText.trim() || DEFAULT_SCREENING_METHOD_TEXT;
    setSaving(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BLOOD_BANK}/blood-bank-config/upsertBloodBankConfig`,
        { screeningMethodText: text },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data?.isSuccess) {
        setScreeningMethodText(
          response.data?.data?.screeningMethodText || text
        );
        toast.success(response.data?.message || "Config saved");
      } else {
        toast.error(response.data?.message || "Failed to save config");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to save config");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 2, maxWidth: 720 }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700, mb: 0.5 }}>
        Other Config
      </Typography>
      <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 2 }}>
        This line is printed on the donor screening report under the serology tests.
      </Typography>
      <TextField
        label="Screening method text"
        value={screeningMethodText}
        onChange={e => setScreeningMethodText(e.target.value)}
        multiline
        minRows={3}
        fullWidth
        disabled={loading}
        className="custom-input"
      />
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={handleSave} disabled={loading || saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default OtherConfig;
